// extracted by mini-css-extract-plugin
module.exports = {"ratingCard":"OrderDetailsFeedback_ratingCard__trNM8","useFade-fadeIn":"OrderDetailsFeedback_useFade-fadeIn__0Fy7h","useFade-fadeOut":"OrderDetailsFeedback_useFade-fadeOut__sZzKt"};